import { fetchFulfillmentCatalogStats } from '@entities/fulfillment/index.server'
import { LandingFigureRow, type LandingFigure } from '@ui/landing'
import { pluralize } from '@utils/formaters'

const numberFormat = new Intl.NumberFormat('ru-RU')
const fulfillmentForms = ['фулфилмент', 'фулфилмента', 'фулфилментов']
const cityForms = ['город', 'города', 'городов']

/**
 * Показатель про каталог. Пока карточек нет, счётчик не показываем: строка «0 фулфилментов»
 * отговаривает оставлять заявку сильнее, чем её отсутствие. Если число не пришло совсем, вместо
 * него идёт устройство самой заявки — оно от сервера не зависит, в отличие от слов про то, что
 * каталог только открылся.
 */
const toCatalogFigure = (fulfillmentCount: number | null): LandingFigure => {
  if (fulfillmentCount === null) {
    return { label: 'Заявка', value: 'Одна на всех', note: 'уходит подходящим фулфилментам' }
  }

  if (fulfillmentCount === 0) {
    return { label: 'Каталог', value: 'Открылся', note: 'фулфилменты подключаются' }
  }

  return {
    label: 'В каталоге',
    value: numberFormat.format(fulfillmentCount),
    // Заявку получают не все карточки каталога, а те, что ведёт живой владелец, — и из них только
    // подходящие. Обещать «столько-то ответов» по числу карточек нельзя.
    note: `${pluralize(fulfillmentCount, fulfillmentForms)}, заявку получат подходящие`,
  }
}

/** Показатель про города забора. Нет числа — говорим о географии сервиса, а не о справочнике. */
const toGeographyFigure = (cityCount: number | null): LandingFigure => {
  if (cityCount === null || cityCount === 0) {
    return { label: 'География', value: 'Вся РФ', note: 'города забора выбираете вы' }
  }

  return { label: 'География', value: numberFormat.format(cityCount), note: pluralize(cityCount, cityForms) }
}

/** Живые числа каталога под первым экраном. */
export const RequestCatalogNumbers = async () => {
  const { cityCount, fulfillmentCount } = await fetchFulfillmentCatalogStats()

  return (
    <LandingFigureRow
      items={[
        toCatalogFigure(fulfillmentCount),
        toGeographyFigure(cityCount),
        { label: 'Стоимость', value: '0 ₽', note: 'заявка, ответы и каталог' },
      ]}
    />
  )
}
